import uiConfig from 'src/lib/ui/config';
import { animate, ImageCoverView, View } from '@play-co/timestep-core/ui';
import ResponsiveScene from './ResponsiveScene';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';
import { Pet } from 'src/replicant/buruburu/pet';
import { createEmitter } from 'src/lib/Emitter';
import {
  getLaunchScene,
  isSceneEntered,
  isSceneEntering,
} from 'src/lib/stateUtils';
import i18n from 'src/lib/i18n/i18n';
import { Transition } from 'src/game/logic/SceneManager';
import platform from '@play-co/gcinstant';
import StateObserver from 'src/StateObserver';

export default class BedroomScene extends ResponsiveScene {
  constructor() {
    super(
      new ImageCoverView({
        ...uiConfig.buruburu.backgroundDefaults,
        ...uiConfig.buruburu.bedroom,
      }),
    );

    this.getView().tag = 'bedroom';

    this.addBed();
    this.addDimmingOverlay();
    this.addSleepingSign();
  }

  private addBed() {
    const scene = this.getView();
    scene.addSubview(new ImageCoverView(uiConfig.buruburu.bedroomBed));
  }

  private addDimmingOverlay() {
    const scene = this.getView();
    const overlay = scene.addSubview(
      new View(uiConfig.buruburu.bedroomOverlay),
    );

    let skipDimTransition = getLaunchScene() === 'bedroom';
    createEmitter(scene, () => isSceneEntering('bedroom')).addListener(
      (isEnteringBedroom) => {
        if (isEnteringBedroom) {
          const { width, height } = scene.style;
          const opacity = skipDimTransition ? 1 : 0;
          overlay.updateOpts({ opacity, width, height });
        }
      },
    );
    createEmitter(
      scene,
      ({ pet }) => isSceneEntered('bedroom') && !pet[platform.playerID].action,
    ).addListener((shouldDimLights) => {
      if (shouldDimLights) {
        animate(overlay).now({ opacity: 1 }, 3000, animate.linear);
        skipDimTransition = false; // Only skip the dim transition when launching into the bedroom
      }
    });
  }

  private addSleepingSign() {
    const scene = this.getView();
    const { bedroomSign, bedroomSignText } = uiConfig.buruburu;
    const { user } = StateObserver.getState();
    const { startHour, endHour } = Pet.ruleset.getSleepingPeriod(user);
    const sign = scene.addSubview(new ImageCoverView(bedroomSign));
    sign.addSubview(
      new LangBitmapFontTextView({
        ...bedroomSignText,
        localeText: () =>
          i18n('sleepingPeriod', {
            startHour: startHour - 12,
            endHour,
          }),
      }),
    );
  }

  public transition(): Transition {
    return 'slide_forward';
  }
}
